import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { usePostHog } from 'posthog-js/react';
import './MapsBanner.css';

const MapsBanner = () => {
  const { t } = useTranslation();
  const posthog = usePostHog();

  return (
    <Link
      to="/maps"
      className="maps-banner"
      onClick={() => posthog?.capture('maps_banner_clicked', { source: 'home_feed' })}
    >
      <div className="maps-banner-text">
        <span className="maps-banner-title">
          {t('mapsBanner.title', 'Every Strava activity, in 40+ artistic styles.')}
        </span>
        <span className="maps-banner-description">
          {t('mapsBanner.description', 'Free, automatic, and on your Strava feed. See the styles.')}
        </span>
      </div>
      <span className="maps-banner-badge">
        {t('mapsBanner.cta', 'Explore')}
      </span>
    </Link>
  );
};

export default MapsBanner;
